export interface UnitsModel {
  id?: number;
  orgId?: number;
  departmentId?: number;
  name?: string;
  description?: string;
  image?: string;
  isActive?: boolean;
  type?: string;
  availableHours?: AvailableHour[];
  adminId?: number;
  department?: Department;
  admin?: Admin;
}

export interface AvailableHour {
  open: string;
  close: string;
}

export interface Department {
  id: number;
  orgId: number;
  name: string;
  description: string;
  image: any;
  type: string;
  isActive: boolean;
  availableHours: AvailableHour2[];
  adminId: number;
}

export interface AvailableHour2 {
  open: string;
  close: string;
}

export interface Admin {
  id: number;
  fullName: string;
  avatar: any;
  password: string;
  photo: any;
  email: string;
  phone: string;
  address: string;
  isActive: boolean;
  position: any;
  country: string;
  city: string;
  passportNumber: any;
  orgId: number;
  workStartTime: any;
  workEndTime: any;
  isVerified: boolean;
  verificationCode: string;
  verificationCodeExpires: string;
  passwordLastChange: string;
  departmentUnitId: any;
  departmentId: any;
  createdAt: string;
}

export interface UnitReqModel {
  name?: string;
  description: string;
  image: any;
  type: any;
  adminId?: number;
  departmentId: number;
  availableHours?: { open: any; close: any }[];
  department?: any;
  unitName?: string;
  assignedAdmin?: any;
}

export enum DepartmentUnitType {
  BARS = 'Bars',
  SPA = 'SPA',
  BEAUTY_SALON = 'Beauty Salon',
  SHOPS = 'Shops',
  TENNIS_COURT = 'Tennis Court',
  RESTURANTS = 'Restaurants',
  ROOM_SERVICE = 'Room Service',
  TRANSPORT = 'Transport'
}
